import { render, staticRenderFns } from "./update-tpl.vue?vue&type=template&id=fdbacc68&"
import script from "./update-tpl.vue?vue&type=script&lang=ts&"
export * from "./update-tpl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports